// extracted by mini-css-extract-plugin
export default {"mealPlanTable":"P_U6DBkFiZLcoSW_phED"};